import * as stylex from '@stylexjs/stylex';
import type { ReactNode } from 'react';
import { styles } from './styles';
export function LabeledSection({
  label,
  icon,
  children
}: {
  label: string;
  icon: ReactNode;
  children: ReactNode;
}) {
  return <section {...stylex.props(styles.section)}>
      <div {...stylex.props(styles.header)}>
        {icon}
        <span {...stylex.props(styles.label)}>{label}</span>
      </div>
      {children}
    </section>;
}